export default function File({
  name,
  register,
  errors,
  rules,
  label,
  accept,
  ...rest
}: {
  name: string;
  register: any;
  errors: any;
  rules?: any;
  label?: string;
  accept?: string;
}) {
  return (
    <div>
      {label && (
        <label>
          {label} {rules?.required && <span className="text-red-600">*</span>}
        </label>
      )}
      <input
        type="file"
        accept={accept}
        className={`${errors[name] && "input-invalid"}`}
        {...register(name, rules)}
        {...rest}
      />
      {errors[name] && (
        <small className="mt-1.5 text-red-600 block">
          {errors[name].message || "This field is required"}
        </small>
      )}
    </div>
  );
}
